/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/SystemBlockValidationTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for System Block Validation Types
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, September 24, 2018 - 6:35 (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      09/24/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    SYSTEMBLOCKVALIDATIONTYPE_LIST_CONTAINER_LOADED,
    SYSTEMBLOCKVALIDATIONTYPE_LIST_CONTAINER_UNLOADED,
    SYSTEMBLOCKVALIDATIONTYPE_LIST_TABLE_LOADED,
    SYSTEMBLOCKVALIDATIONTYPE_LIST_TABLE_UNLOADED,
    SYSTEMBLOCKVALIDATIONTYPE_SELECT_ROW,
    SYSTEMBLOCKVALIDATIONTYPE_ADD,
    SYSTEMBLOCKVALIDATIONTYPE_EDIT,
    SYSTEMBLOCKVALIDATIONTYPE_DELETE,
    SYSTEMBLOCKVALIDATIONTYPE_OPEN_WARNING,
    SYSTEMBLOCKVALIDATIONTYPE_CLOSE_WARNING,
    SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_LOADED,
    SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_UNLOADED,
    SYSTEMBLOCKVALIDATIONTYPE_EDIT_FORM_LOADED,
    SYSTEMBLOCKVALIDATIONTYPE_EDIT_FORM_UNLOADED,
    SYSTEMBLOCKVALIDATIONTYPE_EDIT_DATA_LOAD,
    SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_SUBMIT,
    SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeSystemBlockValidationTypes';

const defaultState = {
    refreshList: false,
    danger: false,
    validationtypeid: 0,
    name: '',
    description: '',
    functionname: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case SYSTEMBLOCKVALIDATIONTYPE_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                validationtypes: action.payload[0] ? action.payload[0].records : null
            }
        case SYSTEMBLOCKVALIDATIONTYPE_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case SYSTEMBLOCKVALIDATIONTYPE_SELECT_ROW:
            return {
                ...state,
                validationtypeid: action.id
            }
        case SYSTEMBLOCKVALIDATIONTYPE_ADD:
            return {
                ...state
            }
        case SYSTEMBLOCKVALIDATIONTYPE_EDIT:
            return {
                ...state,
                validationtypeid: action.id
            }
        case SYSTEMBLOCKVALIDATIONTYPE_DELETE:
            return {
                ...state,
                validationtypeid: null
            }
        case SYSTEMBLOCKVALIDATIONTYPE_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case SYSTEMBLOCKVALIDATIONTYPE_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_LOADED:
        case SYSTEMBLOCKVALIDATIONTYPE_EDIT_DATA_LOAD:
            return {
                ...state,
                validationtypeid: action.payload[0] ? action.payload[0].validationtypeid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                functionname: action.payload[0] ? action.payload[0].functionname : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case SYSTEMBLOCKVALIDATIONTYPE_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case SYSTEMBLOCKVALIDATIONTYPE_LIST_CONTAINER_UNLOADED:
        case SYSTEMBLOCKVALIDATIONTYPE_LIST_TABLE_UNLOADED:
        case SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_UNLOADED:
        case SYSTEMBLOCKVALIDATIONTYPE_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/SystemBlockValidationTypes.js